var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',[_vm._v("404 ,非常抱歉，你要找的页面不见了。")]),_c('div',{staticClass:"button"},[_c('router-link',{attrs:{"to":"/"}},[_c('button',[_vm._v("返回首页")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }